import { Children, isValidElement, type ReactNode } from 'react';
import { cn } from './cn';
import { PALETTE } from '../lib/palette';

interface TItem { color?: string; dot?: ReactNode; label?: ReactNode; children?: ReactNode; }

function TimelineItem(_props: TItem) { return null; }

const COLOR: Record<string, string> = {
  blue: PALETTE.sky[500], green: PALETTE.brand[600], red: PALETTE.danger[500], gray: '#889389', grey: '#889389',
  gold: PALETTE.harvest[400], orange: PALETTE.warning[600],
};
const hex = (c?: string) => (c ? COLOR[c] ?? c : PALETTE.brand[600]);

/** Ant Design `Timeline` replacement — vertical timeline (items or children API). */
export const Timeline = Object.assign(
  function Timeline({ items, className, children }: { items?: TItem[]; mode?: string; className?: string; children?: ReactNode }) {
    const rows: TItem[] = items ?? Children.toArray(children).filter(isValidElement).map((c) => {
      const p = (c as { props: TItem }).props;
      return { color: p.color, dot: p.dot, label: p.label, children: p.children };
    });
    return (
      <ol className={cn('relative ml-1 space-y-5 border-l border-line pl-5', className)}>
        {rows.map((r, i) => (
          <li key={i} className="relative">
            {r.dot ? (
              <span className="absolute -left-[1.65rem] top-0.5 grid size-4 place-items-center rounded-full bg-surface text-2xs [&>svg]:size-3" style={{ color: hex(r.color) }}>{r.dot}</span>
            ) : (
              <span className="absolute -left-[1.4rem] top-1 size-2.5 rounded-full ring-2 ring-surface" style={{ background: hex(r.color) }} />
            )}
            {r.label != null && <div className="text-xs text-subtle">{r.label}</div>}
            <div className="text-sm text-content">{r.children}</div>
          </li>
        ))}
      </ol>
    );
  },
  { Item: TimelineItem },
);
